import Image from 'next/image';
import s from './MasterplanBlock.module.css';
import { MasterPlanBlockProps } from '@/types/model';
import { ImageLoader } from '@/lib/imageLoader';
import { motion } from 'framer-motion';

const MasterplanBlock = ({ footer, imageBlock, list, title }: MasterPlanBlockProps) => {
  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}
      id="masterplanBlock">
      {imageBlock?.url && (
        <div className={s.container__image}>
          <Image
            src={ImageLoader({ src: imageBlock.url })}
            fill
            sizes="(min-width: 62em) 100vw, 750px"
            quality={65}
            alt="map"
          />
        </div>
      )}
      <div className={s.container__info}>
        <h4 className={s.container__info__title}>{title}</h4>
        <ul className={s.container__info__list}>
          {list.map((item) => (
            <li key={item.text}>{item.text}</li>
          ))}
        </ul>
        <p>{footer}</p>
      </div>
    </motion.div>
  );
};

export default MasterplanBlock;
